import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const EKStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.rtnBokfar,
  rutinInfos.rtnUsersEK,
  rutinInfos.rtnKodbehorigheter,
  rutinInfos.rtnTillaggsinfo,
  rutinInfos.rtnRanteTabell,
  rutinInfos.optMomskod,
  rutinInfos.rtnMoms,
  rutinInfos.rtnKonteringskod,
  rutinInfos.rtnEnhet,
  rutinInfos.rtnDetaljeringsniva,
  rutinInfos.rtnSIEMottagningsvag,
  rutinInfos.rtnValuta,
  rutinInfos.rtnSprak,
  rutinInfos.rtnLand,
  rutinInfos.rtnFakturalayout,
  rutinInfos.rtnRapportLayout,
  rutinInfos.rtnBokforingsmall,
  rutinInfos.rtnGavogrupp,
  rutinInfos.rtnGavorubrik,
  rutinInfos.rtnOmrade,
  rutinInfos.rtnBudgetgrupp,
  rutinInfos.rtnBudgetkategori,
  rutinInfos.rtnLonetillagg,
  rutinInfos.rtnBefattningskod,
  rutinInfos.rtnAvtalsomrade,
  rutinInfos.rtnEKLoneart,
];

export default EKStyrvardeMeny;
